
import LoanIcon from "../../../assets/Icons/LoanIcon";
const NotificationList = () => {
  const list = [{
    title: "Loan Eligibility",
    icon: <LoanIcon />,
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore",
    time: "1hr ago",
  },
  {
    title: "Medical Loan Payment due",
    icon: <LoanIcon />,
    desc: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore",
    time: "2hr ago",
  }
  ]
  return (<ul className="flex flex-col gap-[12px]">
    {list.map((item, index) => (
      <li key={index} className="flex gap-[4px] border-b-2 border-[#78666930] py-[8px]">
        <div>
          {item?.icon}
        </div>
        <div >
          <h4 className="font-Apparat font-[700] text-[16px] leading-[19.2px]">{item?.title}</h4>
          <p className="font-Apparat font-[500] text-[16px] leading-[19.2px] text-[#42495270] tracking-[-2%] mt-[4px]">{item?.desc}</p>
        </div>
        <p className="font-Apparat font-[600] text-[12px] leading-[14.4px] text-[#42495247] text-nowrap">{item?.time}</p>
        {/* Notification component */}
      </li>
    ))}
  </ul>)
}

export default NotificationList;